import { AuctionNearMeHit } from '@/pages/AuctionsNearMe/types/AuctionsNearMe.types';
import type { CatalogNearMe, RelatedGeoArea } from './catalogsNearMe.types';

/**
 * Redux state slice for Auctions Near Me page
 *
 * This slice supports both implementations during migration:
 * - Legacy: Algolia search (hits field)
 * - New: catalog-management API (catalogIDs, catalogsNearMe, otherPlaces, pagination, etc.)
 *
 * Feature flag FF_SG229_NEW_AUCTIONS_NEAR_ME_PAGE determines which is used
 *
 * Note: pageSize is managed locally in useAuctionsNearMePagination for display,
 * while API fetches use MAX_CATALOGS_TO_FETCH (1000) for client-side pagination
 */

export type AuctionsNearMeSlice = {
    catalogIds: number[];
    catalogsNearMe: CatalogNearMe[];
    currentPage: number;
    error: string | null;
    /**
     * @deprecated: Algolia search results (hits) (will be removed post-migration to catalog-management API)
     */
    hits: AuctionNearMeHit[];
    loading: boolean;
    otherPlaces: RelatedGeoArea[];
    totalPages: number;
    totalRecords: number;
};

export const defaultAuctionsNearMeSlice: AuctionsNearMeSlice = {
    catalogIds: [],
    catalogsNearMe: [],
    currentPage: 0,
    error: null,
    /**
     * @deprecated: Algolia search results (hits) (will be removed post-migration to catalog-management API)
     */
    hits: [],
    loading: false,
    otherPlaces: [],
    totalPages: 0,
    totalRecords: 0,
};
